import symptom from "@/components/symptom/Symptom";
import symptomIndex from "@/components/symptom/Index";

export default {
  path: "/symptoms",
  component: symptom,
  meta: {
    permission: "symptom:read|symptom:manage"
  },
  children: [
    {
      path: "list",
      name: "symptom-list",
      component: symptomIndex,
      meta: {
        title: "Symptoms",
        permission: "symptom:read|symptom:manage"
      }
    }
  ]
};
